import type { Suggestions } from 'src/components/useSuggestions/useSuggestions';
import type { Partner } from 'src/types';

type GroupedPartners = Record<Partner['type'], Partner[]>;

export const groupPartners = (partners: Partner[]): GroupedPartners =>
  partners.reduce<GroupedPartners>(
    (carry, partner) => ({
      ...carry,
      [partner.type]: [...(carry[partner.type] || []), partner],
    }),
    {} as GroupedPartners,
  );

export const makePartnerSuggestions = (
  partners: Partner[],
): Suggestions<Partner> => {
  const grouped = groupPartners(partners);

  // Setting the order manually
  return [
    makeSuggestion(grouped, 'SEEK Premier Partners'),
    makeSuggestion(grouped, 'SEEK Select Partners'),
    makeSuggestion(grouped, 'SEEK Access Partners'),
  ];
};

const makeSuggestion = (
  partners: GroupedPartners,
  groupName: Partner['type'],
): any => ({
  label: groupName,
  suggestions:
    partners[groupName]?.map((partner) => ({
      text: partner.name,
      slug: partner.id || undefined,
      value: partner,
    })) || [],
});
